import { ContractType } from "@/lib/api/otc";
import { OrderType } from "@/lib/tt/orderType";

export type { OrderType };

export type OtcContractMode = "hedgeable" | "reown" | "amendment";

export interface CustomerSplitEntry {
  /** Unique key for stable React rendering across reorders/removals. */
  key: string;
  customer_id: string;
  /** Quantity as a string (user-facing). Stored as percentage internally on submit. */
  quantity: string;
}

export interface LinkedOrderEntry {
  /** Unique key for stable React rendering across reorders/removals. */
  key: string;
  /** `guid_order_id` linked to this order; "" while the row is still empty. */
  guid_order_id: string;
}

export interface AttachFormValues {
  customerSplits: CustomerSplitEntry[];
  cropYear: string;
  orderType: OrderType;
  otcContractMode: OtcContractMode | null;
  otcContractType: string;
  /**
   * Amendment fields. Mutually exclusive with `otcContractType`: only one
   * OTC-contract intent may be populated at a time.
   */
  amendmentType: string;
  contractNumber: string;
  /** General-contract fields, only used for the HTA and Cash order types. */
  basis: string;
  marketZoneId: string;
  deliveryTerms: string;
  shouldIgnore: boolean;
  isNonClient: boolean;
  /** When true the form shows the linked-order picker and submits `linked_order_ids`. */
  linkedOrderEnabled: boolean;
  /** Orders linked to this one. At least one must be chosen while the picker is on. */
  linkedOrders: LinkedOrderEntry[];
}

export const REOWN_CONTRACT_TYPES = new Set<string>([
  ContractType.BasePriceReown,
  ContractType.RangePriceReown,
  ContractType.ReOwnWDU,
]);
